import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { loginType } from '@/app/(BackOffice)/types/auth/auth';
import AuthSocialButtons from './AuthSocialButtons';
import { CardMedia } from '@mui/material';

const AuthLogin = ({ title, subtitle, subtext }: loginType) => (
  <>
    {title ? (
      <Typography fontWeight="700" variant="h2" mb={1}>
        {title}
      </Typography>
    ) : null}

    {subtext}
    {/* <CardMedia component="img" image="/images/auth/login.png" width={'525px'} height={'350px'}/> */}
    <Box display={'flex'} justifyContent={'center'}>
      <CardMedia component="img" image="/images/auth/login.png" width={'525px'} height={'350px'}/>
    </Box>
    <AuthSocialButtons title="Sign in with" />
  </>
);

export default AuthLogin;
